
import gql from 'graphql-tag'

// """创建学校"""
export const createSchool = gql`
  mutation($input: NewSchoolInput!) {
    createSchool(
      input: $input
    ) {
      id
      name
    }
  }
`

// """更新学校"""
export const updateSchool = gql`
  mutation($input: EditSchoolInput!,$schoolId: Int!) {
    updateSchool(
      input: $input
      schoolId:$schoolId
    ) {
      id
      name
    }
  }
`

// 给学校分配经销商
export const updateSchoolDealers = gql`
  mutation($dealerIds: [Int!]!,$schoolId: Int!) {
    updateSchoolDealers(
      dealerIds: $dealerIds
      schoolId:$schoolId
    ) {
      id
      address
    }
  }
`
